export type RejectedPaymentMethod = 'CARD' | 'ACH' | 'PAD';

export function getRejectedPaymentMethod(
  error: unknown,
  paymentMethod?: string,
): RejectedPaymentMethod | undefined {
  if (!error || typeof error !== 'object') return undefined;

  const response = error as { status?: unknown; error?: unknown };
  if (!response.error || typeof response.error !== 'object') return undefined;

  const body = response.error as { message?: unknown };
  if (typeof body.message !== 'string') return undefined;

  if (response.status === 403) {
    const policy = /^(CARD|ACH|PAD) payments are not allowed(?: by this application configuration)?\.$/.exec(
      body.message,
    );
    if (policy) return policy[1] as RejectedPaymentMethod;
  }

  const isOrderConfigurationPolicyRejection =
    response.status === 400 &&
    body.message === 'Payment method is not allowed by the order application configuration.';
  if (isOrderConfigurationPolicyRejection) {
    const method = paymentMethod?.trim().toUpperCase();
    if (method === 'CARD' || method === 'ACH' || method === 'PAD') return method;
  }

  return undefined;
}
